export default "__VITE_ASSET__Dsr8UzEc__";